import { ScheduleGridBodyCellProps } from 'components/ScheduleGrid/ScheduleGrid.Types';
import { ServiceStore } from '@intrasync/stores';
import { utils } from '@intrasync/utils';
// import { computed } from 'mobx';
// import injectStores from 'components/RootStore/injectStores';

type Status =
  | 'new'
  | 'modeled'
  | 'drawn'
  | 'checked'
  | 'issued for construction';

// interface IFCStatus {
//   id: number;
//   jobNumber: number;
//   markNumber: string;
//   panelModeled: boolean;
//   panelDrawn: boolean;
//   panelChecked: boolean;
//   rearViewIFC: string;
// }

interface ProductionScheduleRightBodyCellProps
  extends ScheduleGridBodyCellProps {
  itemsFromEntity: unknown[];
  ifcStatusStore: ServiceStore;
}

const ProductionScheduleRightBodyCell = (
  props: ProductionScheduleRightBodyCellProps
) => {
  if (props.itemsFromEntity?.length === 0) {
    // console.log('ProductionScheduleRightBodyCell: No items from entity');
    return (
      <div
        style={{
          border: '1px solid #000',
          ...props.style,
          // ...props.styles,
          backgroundColor: '#f0f0f0',
        }}
      />
    );
  }
  const { itemsFromEntity } = props;
  // console.log('itemsFromEntity', itemsFromEntity);

  const itemsByMarkNumber = utils.groupBy(
    itemsFromEntity as Record<string | number, string>[],
    'markNumber'
  );
  // console.log('itemsByMarkNumber', itemsByMarkNumber);

  const currentMarkNumbers = Object.keys(itemsByMarkNumber);
  // console.log('currentMarkNumbers', currentMarkNumbers);
  // const ifcStatusStore = props.ifcStatusStore;
  const currentMainEntity = itemsFromEntity[0] as {
    controlNumber: string;
    markNumber: string;
    castingDate: string;
    jobNumber: number;
    ifcStatus?: Status;
  };
  // console.log('currentMainEntity', currentMainEntity);

  // const ifcStatus = ifcStatusStore?.entities?.find(
  //   (ifcStatus) =>
  //     (ifcStatus.jobNumber as number) === currentMainEntity.jobNumber &&
  //     ifcStatus.markNumber === currentMainEntity.markNumber
  // );

  // console.log('ifcStatus', ifcStatus);

  // const buttonColor = 'transparent';
  // if (itemsFromEntity.length >= 2) {
  //   buttonColor = 'error';
  // }
  const allStatuses: Status[] = [
    'new',
    'modeled',
    'drawn',
    'checked',
    'issued for construction',
  ];
  const drawingStatus: Status =
    allStatuses[
    Math.floor(
      parseFloat(currentMainEntity.controlNumber) % allStatuses.length
    )
    ];
  const statusColor = {
    new: 'gray',
    modeled: 'blue',
    drawn: 'orange',
    checked: 'orange',
    'issued for construction': 'green',
  }[drawingStatus];

  const hardwareConstant = 1.5;
  const hardwareVariability = currentMarkNumbers.length * 0.75;
  const randomHardwareCount = Math.floor(
    itemsFromEntity.length * hardwareConstant + hardwareVariability
  );

  return (
    <div
      style={{
        border: '1px solid #000',
        ...props.style,
        // ...props.styles,
        overflow: 'hidden',
        backgroundColor: '#f0f0f0',
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '5px',
          border: `2px solid ${statusColor}`,
          padding: '5px',
          margin: '5px',
          textAlign: 'center',
          height: '78%',
        }}
      >
        <div>
          <b>{currentMarkNumbers.length}</b> Series
        </div>
        <div>
          <b>{itemsFromEntity.length}</b> Panels
        </div>
        <div>
          <b>{randomHardwareCount}</b> Hardware
        </div>
      </div>
    </div>
  );
};

export default ProductionScheduleRightBodyCell;
